import * as React from 'react';
import { GenericService } from '../GenericService';
import { ServicePrice } from '../ServicePrice';
import * as styles from './StandartService.css';
import { IService } from '../../types';
import { useSelector } from 'react-redux';
import { selectBaseAuctionBetByServiceId } from '../../../../../../../../../selectors/auction';

export const StandardService = ({ selected, blurred, disabled, type, onSelect }: IService) => {
  const price: number = useSelector(selectBaseAuctionBetByServiceId(type));

  return (
    <GenericService
      title="Стандарт"
      subtitle="До х2 звонков"
      className={styles.root}
      serviceType={type}
      selected={selected}
      blurred={blurred}
      disabled={disabled}
      onSelect={onSelect}
    >
      <ServicePrice price={price} suffix="₽/день" />
    </GenericService>
  );
};
